import { createClient } from "@envstash/protocol/client";

export const api = createClient({ origin: typeof location === "undefined" ? "http://localhost" : location.origin });
export { isDefinedError, ORPCError, safe } from "@envstash/protocol/client";

export function errorMessage(e: unknown): string {
  if (e instanceof Error) return e.message;
  return String(e);
}
